export const VraboteniColumns = [
    { name: "SifraID", label: "Шифра", field: "SifraID", align: "left", sortable: true },
    { name: "Naziv", label: "Име и презиме", field: "Naziv", align: "left", sortable: true },
    { name: "email", label: "Е-пошта", field: "email", align: "left" },
    { name: "Tel", label: "Телефон", field: "Tel", align: "left" },
    { name: "Adresa", label: "Адреса", field: "Adresa", align: "left" },
    { name: "UserName", label: "Корисничко име", field: "UserName", align: "left" },
    { name: "aktiven", label: "Статус", field: "aktiven", align: "center" },
    { name: "akcii", label: "Акции", field: "akcii", align: "center" },
  ];